import { Button, Box, Center, Stack, Text, Title } from '@mantine/core'
import { Link, createFileRoute } from '@tanstack/react-router'
import { TbLogin } from 'react-icons/tb'
import logoUrl from '../../logo.svg'

export const Route = createFileRoute('/')({
  component: HomePage,
})

function HomePage() {
  return (
    <Box style={{ minHeight: '100vh', background: '#1a1a2e', position: 'relative', overflow: 'hidden' }}>
      {/* background blobs */}
      <Box style={{
        position: 'absolute', top: '-15%', left: '-10%',
        width: 500, height: 500, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(124,58,237,0.25) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />
      <Box style={{
        position: 'absolute', bottom: '-20%', right: '-10%',
        width: 600, height: 600, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(79,70,229,0.2) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />
      <Box style={{
        position: 'absolute', top: '50%', left: '60%',
        width: 300, height: 300, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(168,85,247,0.1) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <Center mih="100vh" style={{ position: 'relative', zIndex: 1 }}>
        <Stack align="center" gap="xl">
          <img
            src={logoUrl}
            width={72}
            height={72}
            alt="logo"
            style={{ borderRadius: 20, boxShadow: '0 4px 32px rgba(124,58,237,0.5)', display: 'block' }}
          />

          <Stack align="center" gap={8}>
            <Title
              order={1}
              c="white"
              fw={800}
              ta="center"
              style={{ fontSize: '2.6rem', letterSpacing: '-0.5px', lineHeight: 1.15 }}
            >
              Monitoring System
            </Title>
            <Text c="dimmed" ta="center" size="md" maw={320} lh={1.6}>
              Pantau semua aplikasi dalam satu tempat, real-time.
            </Text>
          </Stack>

          <Button
            component={Link}
            to="/login"
            leftSection={<TbLogin size={18} />}
            size="md"
            style={{
              background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
              border: 'none',
              paddingInline: 32,
            }}
          >
            Masuk
          </Button>
        </Stack>
      </Center>
    </Box>
  )
}
